import React from 'react';
import { Box, Chip } from '@material-ui/core';
import { DateFormatter } from 'components/AppTable/CellsComponents';
import i18next from 'i18next';

const formatStatus = value => {
  if (!value) {
    return '—';
  }
  const key = `jobTaskVersions.statuses.${value}`;
  const translated = i18next.t(key);
  return translated === key ? value : translated;
};

const renderNameWithUpdateChip = (name, hasPendingUpgrades) => (
  <Box display="flex" alignItems="center" style={{ gap: 8, flexWrap: 'wrap' }}>
    <span>{name}</span>
    {hasPendingUpgrades ? (
      <Chip
        size="small"
        label={i18next.t('companyProvisioning.pendingUpdate', 'Update')}
        style={{ backgroundColor: '#FFF3E0', color: '#E65100', fontWeight: 600 }}
      />
    ) : null}
  </Box>
);

const getTableConfig = () => {
  return [
    {
      title: i18next.t('tablesLabels.id'),
      field: 'id',
    },
    {
      title: i18next.t('tablesLabels.jobTask'),
      field: 'name',
      isSorting: true,
      dependentField: 'hasPendingUpgrades',
      Component: renderNameWithUpdateChip,
    },
    {
      title: i18next.t('tablesLabels.updatedBy'),
      field: 'fullName',
      isSorting: true,
    },
    {
      title: i18next.t('tablesLabels.lastVersion'),
      field: 'lastVersionCode',
      alignment: 'center',
      Component: value => value || '—',
    },
    {
      title: i18next.t('tablesLabels.lastVersionStatus'),
      field: 'lastVersionStatus',
      alignment: 'center',
      Component: formatStatus,
    },
    {
      title: i18next.t('tablesLabels.lastUpdate'),
      field: 'updatedAt',
      Component: value => <DateFormatter value={value} />,
      isSorting: true,
    },
    {
      // Hidden field for row data access (used for role-based actions)
      title: '',
      field: 'companyId',
      isVisible: false,
    },
    {
      title: '',
      field: 'isFromSystem',
      isVisible: false,
    },
    {
      title: '',
      field: 'hasPendingUpgrades',
      isVisible: false,
    },
  ];
};

export default getTableConfig;
